/**
 * Cart Service — public cart API for the mini-store.
 * Session tracked via x-cart-session header (UUID in localStorage).
 */
import { get, post, put, del } from "../utils/api";

const SESSION_KEY = "prombiz_cart_session";

function getSessionId() {
  let sid = localStorage.getItem(SESSION_KEY);
  if (!sid) {
    sid = crypto.randomUUID();
    localStorage.setItem(SESSION_KEY, sid);
  }
  return sid;
}

function cartHeaders() {
  return { "x-cart-session": getSessionId() };
}

export async function fetchCart(businessSlug) {
  return get(`/public/cart/${businessSlug}`, { headers: cartHeaders() });
}

export async function addToCart(businessSlug, productId, qty = 1) {
  return post(`/public/cart/${businessSlug}/items`, { productId, qty }, { headers: cartHeaders() });
}

export async function updateCartItem(businessSlug, itemId, qty) {
  return put(`/public/cart/${businessSlug}/items/${itemId}`, { qty }, { headers: cartHeaders() });
}

export async function removeCartItem(businessSlug, itemId) {
  return del(`/public/cart/${businessSlug}/items/${itemId}`, { headers: cartHeaders() });
}

export async function clearCart(businessSlug) {
  return del(`/public/cart/${businessSlug}`, { headers: cartHeaders() });
}

export async function checkout(businessSlug, data = {}) {
  return post(`/public/cart/${businessSlug}/checkout`, data, { headers: cartHeaders() });
}
